export const quizEndStatus = {
  submitted: 0,
  closed: 1
}